/* eslint-disable */
import React, { useContext } from 'react';
import { Data, Filters } from '../contexts';
import { parseMoney } from '../../utils';

const monthsList = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const lastDayOfMonth = (y, m) => {
    // By passing m + 1 as the month parameter and 0 as the day parameter, it represents the last day of the specified month
    return new Date(y, m + 1, 0).getDate();
}
// This Year vs. Last Year Comparison
// Actual (This Year) vs. Monthly Forecast Scenario
const CustomQuarterOrMonthYTDReport = (props) => {
    const { monthly_calcs } = useContext(Data);
    const { filters } = useContext(Filters);
    let finalFilters = props.tabFilters || filters;
    const thisYear = monthly_calcs?.you || {};
    const lastYear = monthly_calcs?.you || {};
    const { forecastVals } = props;
    const quarterMonths = props.quarterMonths ? props.quarterMonths : [];
    const forecastYear = Object.keys(forecastVals || {}).length > 0 ? Object.keys(forecastVals['total_revenue'])[0] : null;
    const endMonthOfSelectedYear = finalFilters.date_through_monthly_month && finalFilters.date_through_monthly_year ? Number(finalFilters.date_through_monthly_month) : quarterMonths[2];
    const selectedYear = finalFilters.date_through_monthly_month && finalFilters.date_through_monthly_year ? finalFilters.date_through_monthly_year : props.year
    let monthsAvailable = 0;
    const useableMonths = monthly_calcs?.you?.cash?.[selectedYear] ? Object.values(monthly_calcs?.you?.cash?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
    useableMonths.forEach((thing) => (thing !== null ? (monthsAvailable += 1) : null));
    let compareTitles = []
    let ytdTitles = []

    if (props.tabKey.includes('_month')) {
        const lastDay = lastDayOfMonth(quarterMonths[3], endMonthOfSelectedYear - 1);
        let formatMonth = endMonthOfSelectedYear < 10 ? `0${endMonthOfSelectedYear}` : endMonthOfSelectedYear;
        let thisMonthDate = `${formatMonth}/${lastDay}/${(quarterMonths[3])}`;
        let lastYearMonthDate = `${formatMonth}/${lastDay}/${(quarterMonths[3] - 1)}`;
        compareTitles = props.tabKey.includes('ty_v_ly_month') ? [thisMonthDate, lastYearMonthDate] : [`Act. ${thisMonthDate}`, `For. ${thisMonthDate}`];
        ytdTitles = props.tabKey.includes('ty_v_ly_month') ? ['This Year', 'Last Year'] : ['Actual', `Forecast`];
    } else {
        compareTitles = props.tabKey.includes('ty_v_ly_q') ? ['This Year', 'Last Year'] : ['Actual', `Forecast`];
        ytdTitles = props.tabKey.includes('ty_v_ly_q') ? ['This Year', 'Last Year'] : ['Actual', `Forecast`];
    }

    if (quarterMonths) {
        const cellStyle = {
            borderBottom: 'solid 1px',
        };

        let reportLabel, endMonth;
        let quarterMs = quarterMonths[1] || [];
        const reduceMonths = props.reportPeriod === 'quarter' ? quarterMs : [endMonthOfSelectedYear];
        if (finalFilters.date_through_monthly_month && finalFilters.date_through_monthly_year) {
            // YTD should total with Date Through if selected
            endMonth = endMonthOfSelectedYear
        } else {
            endMonth = Math.max(...quarterMs);
            // In case user has uploaded monthly data before the 16th and the month is beyond the quarter of months.
            endMonth = endMonthOfSelectedYear > endMonth ? endMonthOfSelectedYear : endMonth
        }

        let ytdMonths = Array.from({ length: endMonth }, (_, i) => i + 1);

        if (props.reportPeriod === 'quarter') {
            if (finalFilters.date_through_monthly_month && finalFilters.date_through_monthly_year) {
                let monthIndex = endMonthOfSelectedYear - 1
                reportLabel = `${quarterMonths[0]}, Date Through: ${monthsList[monthIndex]}`;
            } else {
                reportLabel = quarterMonths[0];
            }
        } else if (props.reportPeriod === 'month') {
            let monthIndex = endMonthOfSelectedYear - 1
            reportLabel = monthsList[monthIndex];
        }

        const renderHeaderColumns = () => {
            return (
                <thead>
                    <tr>
                        <td style={cellStyle} colSpan={6}>
                            {reportLabel}
                        </td>
                        <td>
                            {props.tabKey.includes('ty_v_ly') ? `${selectedYear} and ${selectedYear - 1}` : `${selectedYear}`}
                        </td>
                        <td style={cellStyle} colSpan={6}>
                            Year to Date
                        </td>
                    </tr>
                    <tr>
                        <td style={cellStyle}>{compareTitles[0]}</td>
                        <td style={cellStyle} />
                        <td style={cellStyle}>{compareTitles[1]}</td>
                        <td style={cellStyle} />
                        <td style={cellStyle}>$Var</td>
                        <td style={cellStyle}>%Var</td>
                        <td />
                        <td style={cellStyle}>{ytdTitles[0]}</td>
                        <td style={cellStyle} />
                        <td style={cellStyle}>{ytdTitles[1]}</td>
                        <td style={cellStyle} />
                        <td style={cellStyle}>$Var</td>
                        <td style={cellStyle}>%Var</td>
                    </tr>
                </thead>
            )
        };

        const firstRevenueQorMVal = reduceMonths.reduce(
            (sum, month) => sum + (thisYear?.total_revenue?.[selectedYear]?.[month] || 0),
            0,
        );
        const secondRevenueQorMVal = reduceMonths.reduce(
            (sum, month) => sum + (lastYear?.total_revenue?.[selectedYear - 1]?.[month] || 0),
            0,
        );
        const firstRevenueYTDVal = ytdMonths.reduce(
            (sum, month) => sum + (thisYear?.total_revenue?.[selectedYear]?.[month] || 0),
            0,
        );

        const secondRevenueYTDVal = ytdMonths.reduce(
            (sum, month) => sum + (lastYear?.total_revenue?.[selectedYear - 1]?.[month] || 0),
            0,
        );

        const buildRows = () => {
            let monthlyRows = [];
            if (props.naicsCode && props.naicsCode.startsWith('621')) {
                const healthCareRevenueChildKeys = [
                    { key: 'total_revenue_gross_charges', copy: 'Gross Charges' },
                    { key: 'total_revenue_adjustments', copy: 'Adjustments' }
                ];

                let existingKey;
                healthCareRevenueChildKeys.forEach((k) => {
                    existingKey = props.rows.find(r => r.key === k.key);
                    if (!existingKey) {
                        monthlyRows.push(
                            {
                                key: k.key,
                                copy: k.copy,
                                header: false,
                                padding: '',
                                parentKey: 'total_revenue',
                                sheet: 'pnl',
                                commonKey: 'revenue',
                                alwaysDisplayRow: true,
                            }
                        );
                    }
                });

                if (!existingKey) {
                    monthlyRows.push(
                        {
                            key: 'space_before_revenue',
                            copy: '',
                            header: false,
                            padding: '',
                            sheet: 'pnl',
                            emptyRow: true,
                        },
                    );
                }
            }
            monthlyRows = [...monthlyRows, ...props.rows]

            return monthlyRows.map((row, i) => {
                const copyCellStyle = {};
                let underlineFormat = '';
                let toplineFormat = '';
                let firstQorMVal = 0;
                let secondQorMVal = 0;
                let firstYTDVal = 0;
                let secondYTDVal = 0;

                if (!row.header || row.header_is_total) {
                    firstQorMVal = reduceMonths.reduce(
                        (sum, month) => sum + (thisYear?.[row.key]?.[selectedYear]?.[month] || 0),
                        0,
                    );
                    firstYTDVal = ytdMonths.reduce((sum, month) => sum + (thisYear?.[row.key]?.[selectedYear]?.[month] || 0), 0);
                    if (props.tabKey.includes('ty_v_ly')) {
                        secondQorMVal = reduceMonths.reduce(
                            (sum, month) => sum + (lastYear?.[row.key]?.[selectedYear - 1]?.[month] || 0),
                            0,
                        );
                        secondYTDVal = ytdMonths.reduce(
                            (sum, month) => sum + (lastYear?.[row.key]?.[selectedYear - 1]?.[month] || 0),
                            0,
                        );
                    } else if (forecastVals?.[row.key]) {
                        secondQorMVal = reduceMonths.reduce(
                            (sum, month) => sum + (forecastVals?.[row.key]?.[forecastYear]?.[month] || 0),
                            0,
                        );
                        secondYTDVal = ytdMonths.reduce(
                            (sum, month) => sum + (forecastVals?.[row.key]?.[forecastYear]?.[month] || 0),
                            0,
                        );
                    }
                }

                const forecast = row.forecast?.total || row.forecast;
                if (forecast) {
                    if (forecast.boldedUnderline || forecast.underline) {
                        underlineFormat = 'solid 1px';
                        copyCellStyle.textDecoration = 'underline';
                    } else if (forecast.doubleUnderline) {
                        underlineFormat = 'double 1px';
                        copyCellStyle.textDecoration = 'underline';
                    }

                    if (forecast.topline) {
                        toplineFormat = 'solid 1px';
                        copyCellStyle.textDecoration = 'underline';
                    }
                }

                if (row.topline) {
                    toplineFormat = 'solid 1px';
                    copyCellStyle.textDecoration = 'underline';
                }

                const copyRowStyle = {
                    borderBottom: underlineFormat,
                    borderTop: toplineFormat,
                };

                const hideRow = '';
                if (row.emptyRow || (row.header && !row.header_is_total)) {
                    return (
                        <tr key={Math.random(i)} id={`${props.chart}-report-row-${i}`} style={{'height': '20px'}}>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td className="table-copy-center" style={copyCellStyle}>
                                {row.copy}
                            </td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                        </tr>
                    );
                }
                const arrowCellClass = props.pdf ? 'common-size-arrow-pdf' : 'common-size-arrow';
                const backgroundStyle = {};
                const commonSizeValCellClass = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell';
                const valueCellClass = '';

                const varPercent1 = (firstQorMVal - secondQorMVal) / secondQorMVal || 0;
                const varPercent2 = (firstYTDVal - secondYTDVal) / secondYTDVal || 0;
                return (
                    <tr key={Math.random(i)} id={`${props.chart}-report-row-${i}`}>
                        <td style={copyRowStyle}>{parseMoney(firstQorMVal)}</td>
                        <td style={copyRowStyle} className="common-size-cell">
                            {`${((firstQorMVal / firstRevenueQorMVal) * 100).toFixed(2)}%`}
                        </td>
                        <td style={copyRowStyle}>{parseMoney(secondQorMVal)}</td>
                        <td style={copyRowStyle} className="common-size-cell">
                            {`${((secondQorMVal / secondRevenueQorMVal) * 100).toFixed(2)}%`}
                        </td>
                        <td style={copyRowStyle}>{parseMoney(firstQorMVal - secondQorMVal)}</td>
                        <td style={copyRowStyle}>{`${(varPercent1 * 100).toFixed(2)}%`}</td>
                        <td className="table-copy-center" style={copyCellStyle}>
                            {row.copy}
                        </td>
                        <td style={copyRowStyle}>{parseMoney(firstYTDVal)}</td>
                        <td style={copyRowStyle} className="common-size-cell">
                            {`${((firstYTDVal / firstRevenueYTDVal) * 100).toFixed(2)}%`}
                        </td>
                        <td style={copyRowStyle}>{parseMoney(secondYTDVal)}</td>
                        <td style={copyRowStyle} className="common-size-cell">
                            {`${((secondYTDVal / secondRevenueYTDVal) * 100).toFixed(2)}%`}
                        </td>
                        <td style={copyRowStyle}>{parseMoney(firstYTDVal - secondYTDVal)}</td>
                        <td style={copyRowStyle}>{`${(varPercent2 * 100).toFixed(2)}%`}</td>
                    </tr>
                );
            });
        }

        if (props.pdf) {
            // 'report-pdf-landscape'
            const clientNames = props.realName
                ? `${props.realName} / ${props.clientName}`
                : props.clientName;
            const printViewClass = 'money-pdf-portrait';

            return (
                <div className="portrait-view">
                    <div className={printViewClass}>
                        <div>
                            <div>
                                <p className="report-annual-title">{props.title}</p>
                                <p className="report-company-title">{clientNames}</p>
                            </div>
                            <div className="money-pdf-table-div">
                                <table style={{ whiteSpace: 'pre' }} className="money-pdf-table">
                                    {renderHeaderColumns()}
                                    <tbody>{buildRows()}</tbody>
                                </table>
                            </div>
                        </div>
                        <p className="pdf-disclaimer-text">{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
                    </div>
                </div>
            );
        }
        const tableID = `new-annual-table-${props.sheet}`;
        return (
            <div className="money-report-card">
                <div className="money-report-pdf">
                    <div className="money-report-container">
                        <table id={tableID} style={{ whiteSpace: 'pre' }} className="report-table">
                            {renderHeaderColumns()}
                            <tbody>{buildRows()}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
        
    }
    return <div className="money-report-card">This report requires Monthly Data.</div>;
}

export default CustomQuarterOrMonthYTDReport;
